import { Map } from '../definitions/types';
import getConfig from '../config';

const { jimdoDomain } = getConfig();

export const A_JIMDO_HOST = `https://a.${jimdoDomain}`;
export const COOKIE_DOMAIN = `.${jimdoDomain}`;

export const BUNCHBOX_ASSETS_ENDPOINT = 'https://cdn.bunchbox.co/587e16f425e5a09e4bd647df.min.js';
export const BUNCHBOX_ASSETS_ENDPOINT_JAPAN =
  'https://cdn.bunchbox.co/5bdc684f758af02a7334b1e8.min.js';
export const TRACKING_ASSETS_ENDPOINT = `${A_JIMDO_HOST}/app/signup/tracking/assets/`;
export const USERNAME_VALIDATION_ENDPOINT = `${A_JIMDO_HOST}/app/signup/website/validate`;
export const GET_PRICE_ENDPOINT = `${A_JIMDO_HOST}/app/price/index/cartprice/package`;
export const GET_DOMAIN_PRICE_ENDPOINT = `${A_JIMDO_HOST}/app/price/index/domaingroupprice/group/`;
export const VALIDATE_DOMAIN_ENDPOINT = `${A_JIMDO_HOST}/app/order/widget/checkdomain/lang`;
export const CHECKOUT_START_ENDPOINT = `${A_JIMDO_HOST}/app/billing/checkout/entry`;
export const READY_ENDPOINT = `${A_JIMDO_HOST}/app/signup/website/ready`;
export const CREATE_ENDPOINT = `${A_JIMDO_HOST}/app/signup/website/create`;
export const GENERATE_CHECKOUT_CONFIG_ENDPOINT = `${A_JIMDO_HOST}/app/order/widget/checkout/lang`;
export const MOBILE_CMS_INFO_ENDPOINT = `${A_JIMDO_HOST}/app/auth/signin/direct/s`;
export const TRACKING_IFRAME_ENDPOINT = `${A_JIMDO_HOST}/app/signup/tracking/iframe`;

export const PRICE_PRO = 'pro';
export const PRICE_BUSINESS = 'business';

export const PACKAGE_TYPE_FREE = 'free';
export const PACKAGE_TYPE_PRO = 'pro';
export const PACKAGE_TYPE_BUSINESS = 'business';
export const PACKAGE_TYPE_SHOP = 'shop';
export const PACKAGE_TYPE_PLATIN = 'platin';
export const PACKAGE_TYPE_SEO = 'seo';

export const PRODUCT_TYPE_CREATOR = 'creator';
export const PRODUCT_TYPE_DOLPHIN = 'dolphin';
export const PRODUCT_TYPE_ONESTOP = 'onestop'; // TODO cleanup GRW-1410

export const DOMAIN_GROUP_TYPE_A = 'A';

export const BUNDLE_TYPE_SHOP = 'JimdoShop';
export const BUNDLE_TYPE_PLATIN = 'JimdoPlatin';
export const BUNDLE_TYPE_PLATINUM = 'JimdoPlatinum';
export const BUNDLE_TYPE_SEO = 'JimdoSeo';
export const BUNDLE_TYPE_SEO_JAPAN = 'JimdoSEOPlus';

export const PACKAGE_ADDON_SHOP_PAYMENT_METHODS = 24;
export const PACKAGE_ADDON_RANKINGCOACH = 25;
export const PACKAGE_ADDON_PLATIN = 28;
export const PACKAGE_ADDON_EMAIL_ACCOUNT = 4;
export const PACKAGE_ADDON_EMAIL_PACKAGE = 9;

export const ADDITIONAL_ADDONS_PRO = {
  additional_products_to_offer: [PACKAGE_ADDON_EMAIL_ACCOUNT, PACKAGE_ADDON_EMAIL_PACKAGE],
};
export const ADDITIONAL_ADDONS_BUSINESS = {
  additional_products_to_offer: [
    PACKAGE_ADDON_RANKINGCOACH,
    PACKAGE_ADDON_EMAIL_ACCOUNT,
    PACKAGE_ADDON_EMAIL_PACKAGE,
  ],
};

export const PLATIN_PACKAGE_ADDONS = [
  PACKAGE_ADDON_SHOP_PAYMENT_METHODS,
  PACKAGE_ADDON_RANKINGCOACH,
  PACKAGE_ADDON_PLATIN,
];

export const PLATINUM_PACKAGE_ADDONS = [PACKAGE_ADDON_RANKINGCOACH, PACKAGE_ADDON_PLATIN];

export const SHOP_PACKAGE_ADDONS = [PACKAGE_ADDON_SHOP_PAYMENT_METHODS];

export const SEO_PACKAGE_ADDONS = [PACKAGE_ADDON_RANKINGCOACH];

export const TRIAL_TYPE_PRO = 'pro';
export const TRIAL_TYPE_PRO_7DAYS = 'pro-week';
export const TRIAL_TYPE_PRO_2WEEKS = 'pro-2weeks';
export const TRIAL_TYPE_PRO_1YEAR = 'pro-year';
export const TRIAL_TYPE_BUSINESS = 'business';
export const TRIAL_TYPE_BUSINESS_7DAYS = 'business-week';
export const TRIAL_TYPE_BUSINESS_2WEEKS = 'business-2weeks';
export const TRIAL_TYPE_BUSINESS_1YEAR = 'business-year';

export const FADE_IN_OUT_FAST = 'fast';
export const FADE_IN_OUT_NORMAL = 'normal';
export const FADE_IN_OUT_SLOW = 'slow';

export const WAIT_FOR_WEBSITE_READY = 30000;
export const READY_CHECK_INTERVAL = 2000;

export const WEBSITE_ID_UNKNOWN = 'unknown';

export const DEFAULT_LANG = 'en';

export const ANALYTICS_EVENT_CATEGORY = 'the-signup-flow';
export const GTM_UA_EVENT_NAME = 'uaevent';

export const LANG_TO_LOCALE_MAP: Map<string> = {
  en: 'en_US',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  it: 'it_IT',
  ja: 'ja_JP',
  nl: 'nl_NL',
};

export const DOMAIN_TLDS: string[] = [
  '.com',
  '.net',
  '.org',
  '.biz',
  '.info',
  '.de',
  '.at',
  '.ch',
  '.fr',
  '.eu',
  '.nl',
  '.com.mx',
  '.es',
  '.co.uk',
  '.it',
  '.ru',
  '.рф',
  '.pl',
  '.be',
  '.com.pl',
  '.se',
  '.me',
  '.li',
  '.name',
  '.website',
  '.online',
  '.shop',
  '.store',
  '.click',
  '.rocks',
  '.nu',
];

export const AFFILIATES_ALLOWED_FOR_DOLPHIN_WHITELIST: string[] = [
  'a1009250',
  'a1009236',
  'a1008941',
  'a428593',
  'a1005829',
  'a1002691',
  'a890519',
  'a341930',
  'a108928',
  'a1003975',
  'a1002045',
  'a428593',
  'a108928',
  'a1009220',
  'a1003906',
  'a1006873',
  'a1006563',
  'a1005358',
  'a1007942',
  'a1004305',
  'a1003286',
  'a1004430',
  'a1008727',
  'a900967',
  'a1006241',
  'a1009291',
  'a1009316',
  'a1009391',
  'a1009389',
  'a1009393',
  'a1009392',
  'a1009388',
  'a1009324',
  'a1009378',
  'a1009379',
  'a1009380',
  'a1009381',
  'a1009363',
  'a1008934',
  'a1002606',
  'a1005683',
  'a1005682',
  'a1005684',
  'a1008641',
  'a1008933',
  'a1008935',
  'a1009204',
  'a1009254',
];

export const breakpoints = {
  mobileSmall: '320px',
  mobileMedium: '481px',
  mobileLarge: '768px',
  tablet: '990px',
  mediumDesktop: '1100px',
  largeDesktop: '1440px',
};

export const TEMPLATES_PER_PAGE = 18;
